import React, { useCallback } from 'react';
import { SearchInput } from 'components/Atoms';
import withFilter, { FILTER_KEY } from 'hooks/withFilter';
import useActions from 'hooks/useActions';
import { debounced } from 'utilities/common';
import { setCampaignsMobile } from 'states/common/actions';

const SearchCampaign = ({ filters, setFiltersFieldAction }) => {
  const setCampaignsMobileAction = useActions(setCampaignsMobile);

  const _search = useCallback(
    (value) => {
      debounced(() => {
        setCampaignsMobileAction({});
        setFiltersFieldAction({ ...filters, skip: 0, terms: value });
      });
    },
    [filters]
  );

  return (
    <SearchInput
      className={filters?.terms ? 'ant-input-affix-wrapper-focused' : ''}
      defaultValue={filters?.terms || ''}
      onChange={_search}
    />
  );
};

export default withFilter({ filterKey: FILTER_KEY.CAMPAIGN_LIST })(
  SearchCampaign
);
